
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f","stroke-linecap":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"stroke-linejoin":"round","d":"M2.5 4.5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1z"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"stroke-linejoin":"round","d":"M11.5 1.5v3m-6-3v3"}}),_c('path',{staticClass:"i-stroke_3",attrs:{"d":"m6.263 7 2.232 2.217m0 0 2.271 2.257M8.495 9.217l-2.232 2.257m2.232-2.257L10.687 7"}})])])
          )
        }
      }
    